import { useMemo, useRef, useState } from 'react';
import { CheckList, Popup } from 'antd-mobile';
import { Select } from 'antd';
import {
  array,
  object,
  string,
} from 'prop-types';
import styles from './CheckList.module.scss';

const CheckListMobile = ({
  items,
  name,
  placeholder,
  columnDataChildren,
  form,
}) => {
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  // ToDo - add search functionality
  // eslint-disable-next-line no-unused-vars
  const [searchText, setSearchText] = useState(null);
  const [value, setValue] = useState();

  if (!items || !items.length || !columnDataChildren || !columnDataChildren.length) return null;

  const selectedRef = useRef();

  const filteredItems = useMemo(() => {
    if (searchText) {
      return items.filter((item) => item.includes(searchText));
    }
    return items;
  }, [items, searchText]);

  const formatedValues = (values) => values.map((v) => v);

  const findKeyForValue = (v) => v.map((val) => {
    const keyComponent = columnDataChildren.find((child) =>
      child.props.children === val);
    return keyComponent.key;
  });

  return (
    <>
      <Select
        open={!visible}
        onClick={() => setVisible(true)}
        ref={selectedRef}
        value={value}
        mode="multiple"
        showSearch={false}
        placeholder={placeholder}
        maxTagCount="responsive"
        dropdownStyle={{ display: 'none' }}
        dropdownRender={() => <span />}
      />
      <Popup
        visible={visible}
        onMaskClick={() => {
          setVisible(false);
        }}
        destroyOnClose
      >
        <div className={styles.checkListContainer}>
          <CheckList
            multiple
            name={name}
            className={styles.myCheckList}
            defaultValue={selected ? [selected] : []}
            onChange={(v) => {
              setValue(formatedValues(v));
              setSelected(formatedValues(v));
              if (name) {
                form?.setFieldsValue({ [name]: findKeyForValue(formatedValues(v)) });
              }
            }}
          >
            {filteredItems.map((item) => (
              <CheckList.Item key={item.value} value={item.value}>
                {item.label}
              </CheckList.Item>
            ))}
          </CheckList>
        </div>
      </Popup>
    </>
  );
};

CheckListMobile.propTypes = {
  items: array.isRequired,
  name: string.isRequired,
  placeholder: string,
  columnDataChildren: array.isRequired,
  form: object.isRequired,
};

CheckListMobile.defaultProps = {
  placeholder: '',
};

export default CheckListMobile;
